export default class AtlasMergePrepLogModel {
  logs: Record<string, any[]>;
  sortedKeys: string[];
}
